import {
  OnboardingSurveyOptionId,
  Survey,
  SurveyAnswer,
  SurveyAnswerContinuationContext,
  SurveyOption,
  SurveyProvider,
} from "@/data/onboarding.data";
import { getOccupationSurvey } from "@/actions/db/survey";
import { OnboardingSurveyOption } from "@prisma/client";
import {
  buildSurveyOtherOption,
  buildSurveySelectionOption,
} from "@/components/pages/onboarding/utils/onboarding.utils";

export const useOccupationSurvey = (): SurveyProvider => {
  const mapSurveyOption = (
    surveyOption: OnboardingSurveyOption,
  ): SurveyOption => {
    const id = surveyOption.id as OnboardingSurveyOptionId;

    switch (id) {
      case "occupation/music-producer":
        return buildSurveySelectionOption(id, "Music producer");
      case "occupation/vocalist":
        return buildSurveySelectionOption(id, "Vocalist");
      case "occupation/songwriter":
        return buildSurveySelectionOption(id, "Songwriter");
      case "occupation/video-creator":
        return buildSurveySelectionOption(id, "Video creator");
      case "occupation/other":
        return buildSurveyOtherOption(id);
      default:
        throw new Error(`Unknown option id: ${surveyOption.id}`);
    }
  };

  const fetchSurvey = async (): Promise<Survey> => {
    const survey = await getOccupationSurvey();

    if (!survey) {
      throw new Error(`Occupation survey not found`);
    }

    return {
      title: "Which of the following best describes you?",
      otherTitle: "Tell us more about your role",
      options: survey.OnboardingSurveyOptions.map((option) =>
        mapSurveyOption(option),
      ),
      handleSubmitAnswer,
    };
  };

  const handleSubmitAnswer = async (
    answer: SurveyAnswer,
  ): Promise<SurveyAnswerContinuationContext> => {
    return { type: "next" };
  };

  return {
    fetchSurvey,
  };
};
